






















import mixins from 'vue-typed-mixins'
import WindowResizeListener from '@/abstract/WindowResizeListener'
import SchemeMenu from '@/components/Scheme/SchemeMenu.vue'
import Icon from '@/components/Icon/Icon.vue'
import { RouteNames } from '@/router'

import type { RawLocation } from 'vue-router'
import type { ScriptUnit } from '@/models/scripts'

interface Computed {
  scriptItem?: ScriptUnit
  versionCreateRoute: RawLocation
  schemeHref: RawLocation
}

interface Props {
  scriptId: string
  instanceId: string
  showScheme: boolean
}

export default mixins(WindowResizeListener).extend<{}, {}, Computed, Props>({
  components: {
    Icon,
    SchemeMenu,
  },
  props: {
    scriptId: {
      required: true,
    },
    instanceId: {
      required: true,
    },
    showScheme: {
      default: false,
    },
  },
  computed: {
    scriptItem(): ScriptUnit | undefined {
      return this.$store.getters.getScriptById(this.scriptId)
    },
    versionCreateRoute(): RawLocation {
      return {
        name: RouteNames.VersionCreate,
        params: { scriptId: this.scriptId },
      }
    },
    schemeHref(): RawLocation {
      return {
        name: RouteNames.ScriptSchemeEdit,
        params: { scriptId: this.scriptId, instanceId: this.instanceId },
      }
    },
  },
})
